// extracted by mini-css-extract-plugin
module.exports = {"container":"_1zDizZf24NDWsJC40dOISj","pendingOrder":"_3m7IBskDntCS5FJB3CJeKY","suggestedTip":"QTJJXU-fglYQnzyEP66o1","orderContainer":"_3j9ZwOPwP1O9i7-XvRIFYq"};